import { createObservableInstance } from '../../../../helpers';
import PropertyState from '../../../shared/PropertyState';
import EpcState from './EpcState';
import TenanciesState from './TenanciesState';

class LandlordPropertyState extends PropertyState {
  init() {
    super.init();
    this.tenancies = createObservableInstance(TenanciesState, this);
    this.epcData = createObservableInstance(EpcState, this);
  }

  destroy() {
    super.destroy();
    this.tenancies.destroy();
    this.epcData.destroy();
  }
}

LandlordPropertyState.annotations = {
  ...PropertyState.annotations,
};

export default LandlordPropertyState;
